var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindSimilarItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.75C1 5.95979 1.71116 4.2429 2.97703 2.97703C4.2429 1.71116 5.95979 1 7.75 1C9.63704 1.0071 11.4483 1.74342 12.805 3.055L14.5 4.75M10.75 4.75H14.5V1M14.5 7.75C14.5 9.54021 13.7888 11.2571 12.523 12.523C11.2571 13.7888 9.54021 14.5 7.75 14.5C5.86296 14.4929 4.05173 13.7566 2.695 12.445L1 10.75M1 14.5V10.75H4.75",
    stroke: "#8F333B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindSimilarItems);
export default __webpack_public_path__ + "static/media/find-similar-items.ff8594e079d19423de41e3c83302bc2c.svg";
export { ForwardRef as ReactComponent };